import store from "../../../store/store"
import {MessageBox,Message} from 'element-ui'
import config from '../config'
export default {
	img(url){
		if(url){
            if(url.indexOf('http') >= 0){
                return url
            }
			return config.baseUrl + url;
		}
		return '';
	},
	cloneObj(obj){
		return JSON.parse(JSON.stringify(obj));
	},
	generateUUID() {
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    },
	checkPermission(permission){
		return true;
        let routers = store.getters['admin/routers'];
        if(routers.indexOf(permission) >= 0){
        	return true;
        }
        return false;
	},
	cacheSet(key, value){
		localStorage.setItem(key, value);
	},
	cacheGet(key){
		return localStorage.getItem(key);
	},

	showImage(image) {
		MessageBox.alert('<img src="'+ image +'" style="width: 100%" />', {
			dangerouslyUseHTMLString: true
		});
	},
    showKeyword(str, keyword){
        if(!str){
            return ''
        }
        if(!keyword){
            return str
        }
        return str.replace(keyword, '<span style="color:red; font-size: 12px;">'+ keyword +'</span>')
    },
    copy(content){
        const ele = document.createElement('input')
        ele.setAttribute('value', content)
        document.body.appendChild(ele)
        ele.select()
        document.execCommand('copy')
        document.body.removeChild(ele)
        Message({
            message: '复制成功',
            type: 'success'
        })
    },
    calStyle(config){
        let style = {}
        if(config.backgroundColor){
            style.backgroundColor = config.backgroundColor
        }
        if(config.color){
            style.color = config.color
        }
        if(config.fontSize){
            style.fontSize = config.fontSize + 'px'
        }
        if(config.marginLeft){
            style.marginLeft = config.marginLeft + 'px'
        }
        if(config.marginTop){
            style.marginTop = config.marginTop + 'px'
        }
        if(config.marginRight){
            style.marginRight = config.marginRight + 'px'
        }
        if(config.marginBottom){
            style.marginBottom = config.marginBottom + 'px'
        }

        if(config.paddingLeft){
            style.paddingLeft = config.paddingLeft + 'px'
        }
        if(config.paddingTop){
            style.paddingTop = config.paddingTop + 'px'
        }
        if(config.paddingRight){
            style.paddingRight = config.paddingRight + 'px'
        }
        if(config.paddingBottom){
            style.paddingBottom = config.paddingBottom + 'px'
        }

        if(config.borderRadius){
            style.borderRadius = config.borderRadius + 'px'
        }

        if(config.width){
            style.width = config.width + 'px'
        }
        if(config.height){
            style.height = config.height + 'px'
        }
        if(config.textAlign){
            style.textAlign = config.textAlign
        }
        if(config.fontWeight){
            style.fontWeight = config.fontWeight
        }
        if(config.fontStyle){
            style.fontStyle = config.fontStyle
        }
        return style
    },
    dateFormat(date){
        let y = date.getFullYear()
        let m = date.getMonth()
        let d = date.getDate()
        m += 1
        let str = y + '-'
        if(m < 10){
            str += '0' + m
        }else{
            str += m
        }
        str +='-'
        if(d < 10){
            str += '0' + d
        }else{
            str += d
        }
        return str
    },
  dateFormatYmdhm(date){
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`
  },
  dateFormatYmd(date){
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`
  },
  dateFormatHm(date){
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${hours}:${minutes}`
  },
  formatDateTime(stringDate) {
    const date = new Date(stringDate);

    // 格式化为 "YYYY-MM-DD HH:mm"
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return new Date(year, month, day, hours || 0, minutes || 0)
  },


  getTime(date) {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return  `${hours}:${minutes}`;
  },

    richText(html) {
        if(!html){
            return ''
        }
        let newContent= html.replace(/<img[^>]*>/gi,function(match,capture){
         match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
         match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
         match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
         return match;
        });
        newContent = newContent.replace(/style="[^"]+"/gi,function(match,capture){
         match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
         return match;
        });
        // newContent = newContent.replace(/<br[^>]*\/>/gi, '');
        newContent = newContent.replace(/\<img/gi, '<img style="max-width:100%;height:auto;display:block;margin:0 auto; font-size: 0;"');
        newContent = newContent.replace(/\<video/gi, '<video style="max-width:100%;height:auto;display:block;margin:0 auto; font-size: 0;"');
        // newContent = newContent.replace(/src="(.*?)"/gi, 'src="'+ this.img('$1') +'"');
        return newContent;
    },
    getCurrentSchoolYear(list){
        let t = Number(new Date())
        let obj = list.length > 0 ? list[0] : null
        for(var i in list){
            let v = list[i]
            if(Number(new Date(v.beginDate)) <= t && Number(new Date(v.endDate)) >= t){
                obj = v
                break
            }
        }
        return obj
    },
    getCurrentSemester(list){
        let now = new Date()
        let current = list.length > 0 ? list[0] : null
        for(var i in list){
            let v = list[i]
            if(v.beginDate && v.endDate){
                let beginDate = new Date(v.beginDate)
                let endDate = new Date(v.endDate)
                if(now >= beginDate && now <= endDate){
                    current = v
                    break
                }
            }
        }
        return current
    },
    showPrice(price){
        if(!price){
            return 0
        }
        let p = Number(price)
        if(p > 0){
            return p.toFixed(2)
        }else if(p < 0){
            return p.toFixed(2)
        }
        return 0
    },
    calculateAge(idCard){
        if(!idCard || idCard.length < 14){
            return ''
        }
        let birthYear = parseInt(idCard.substring(6, 10))
        let birthMonth = parseInt(idCard.substring(10, 12))
        let birthDay = parseInt(idCard.substring(12, 14))
        
        let today = new Date()
        let currentYear = today.getFullYear()
        let currentMonth = today.getMonth() + 1
        let currentDay = today.getDate()
        
        let age = currentYear - birthYear
        
        if(currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)){
            age--
        }
        
        return age >= 0 ? age : ''
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/util/util.js